import WildAppResource from "./WildAppResource";

export const TEXAS_TAR = 11010;
export const TEXAS_TXR_2019 = 11020;
export const TEXAS_TREC = 11030;
export const TEXAS_TREC_2019 = 11040;
export const TEXAS_EBBY_HALLIDAY = 11050;
export const REX = 11060;
export const CALIFORNIA_CAR = 11070;
export const MARYLAND = 11080;
export const NORTH_CAROLINA = 11090;
export const OHIO = 11100;
export const OKLAHOMA = 11110;
export const SOUTH_CAROLINA = 11120;
export const COLORADO = 11130;
export const ARIZONA = 11140;
export const NEVADA = 11150;
export const PENNSYLVANIA = 11160;
export const DELAWARE = 11170;

export const ALL = {
    TEXAS_TAR,
    TEXAS_TXR_2019,
    TEXAS_TREC,
    TEXAS_TREC_2019,
    TEXAS_EBBY_HALLIDAY,
    REX,
    CALIFORNIA_CAR,
    MARYLAND,
    NORTH_CAROLINA,
    OHIO,
    OKLAHOMA,
    SOUTH_CAROLINA,
    COLORADO,
    ARIZONA,
    NEVADA,
    PENNSYLVANIA,
    DELAWARE,
};

class LuDisclosureFormAppResource extends WildAppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'lu-disclosure-form';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'lus/disclosures/forms';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'slug',
            'title',
            'description',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {};
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {};
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            slug: {
                type: 'string',
                presence: true,
                length: {
                    maximum: 255,
                },
            },
            title: {
                type: 'string',
                presence: true,
                length: {
                    maximum: 255,
                },
            },
            description: {
                type: 'string',
                length: {
                    maximum: 255,
                },
            },
        };
    }
}

export default LuDisclosureFormAppResource;
